module.exports = __webpack_public_path__ + "static/media/mode-540.29192d4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-540.svg
// module id = 1056
// module chunks = 2